export default __webpack_public_path__ + "static/media/sato2.41725a50.JPG";